import React from "react";
import { LinearProgress, Table, TableBody, TableCell, TableContainer, TableRow } from "@mui/material";
import Box from "@mui/material/Box";
import { styled } from "@mui/material/styles";
import { CustomTooltip } from "../../consts";
import { getComparatorSort } from "../../helpers";

const ProgressTable = ({
    data,
    capCase,
    maxItems,
    sortKey,
    filterKey,
    getColorFn = () => "inherit", // default fallback
    getValueFn = (item) => Math.min(item[sortKey], 100)
}) => {
    if (!data || data.length === 0) return null;

    const filteredData = data.sort(getComparatorSort('desc', sortKey)).slice(0, maxItems);

    const StyledTableCell = styled(TableCell)(() => ({
        border: "none",
        padding: "0 .5rem",
        textWrap: "nowrap",
        minWidth: 80,
        textTransform: "capitalize",
    }));

    const StyledTableRow = styled(TableRow)(() => ({
        "& td, & th": {
            border: "none",
            backgroundColor: "transparent",
            height: 28,
        },
    }));

    // to return tooltip title based on value type
    const getToolTipTitle = (item) => {
        if (Array.isArray(item[sortKey])) {
            return item[sortKey].length;
        }
        return getValueFn(item);
    }

    return (
        <Box mt={2} display="flex" flexDirection="column" alignItems="center" gap={1}>
            <TableContainer>
                <Table size="small">
                    <TableBody>
                        {filteredData.map((item, index) => (
                            <StyledTableRow key={index}>
                                <StyledTableCell align="right">
                                    {capCase(item[filterKey])}
                                </StyledTableCell>
                                <StyledTableCell align="left" width="100%">
                                    <CustomTooltip title={getToolTipTitle(item)} followCursor>
                                        <LinearProgress
                                            aria-label={getToolTipTitle(item)}
                                            variant="determinate"
                                            color={getColorFn(item)}
                                            value={getValueFn(item)}
                                        />
                                    </CustomTooltip>
                                </StyledTableCell>
                            </StyledTableRow>
                        ))}
                    </TableBody>
                </Table>
            </TableContainer>
        </Box>
    );
};

export default ProgressTable;